import React, { useEffect, useRef, useState } from 'react';

//* import MUI
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import LinearProgress from '@mui/material/LinearProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axios from "axios";

//* import sub component
import FieldEntriesModal from '../FieldEntriesModal/FieldEntriesModal';

//* import Css
import cssClasses from "./UploadingDataModal.module.css";


//* import npm 
import * as XLSX from "xlsx";
import { Typography } from '@mui/material';
import { errorTost, successTost } from '../../Services/Toast';
import Button from '../../Subcomponents/Button';
import { useParams } from 'react-router-dom';
import { updateFlagsToProjectTable } from '../../Services/Project';
import _, { chunk } from 'lodash';

function UploadingDataModal({ open, handleClose, uploadExcelFile, allUnits, respValue, sdrPercent, legalChargeVal, registrationCharges }) {

  const [isFieldEntriesModalOpen, setIsFieldEntriesModalOpen] = useState(false);

  const [stepperValue, setStepperValue] = useState(1);
  const [totalEntriesCount, setTotalEntriesCount] = useState(0);
  const [Count, setCount] = useState(0);
  const countRef = useRef(0);
  const newEntriesCount = useRef(0)
  const { projectId } = useParams();
  const [DatabaseEntries, setDatabaseEntries] = useState(0);
  const UnitsList = useRef([]);
  const fieldServerEntriesArray = useRef([]);
  const [isFieldLocalEntriesModalOpen, setIsFieldLocalEntriesModalOpen] = useState(false);
  const [fieldLocalEntriesArray, setFieldLocalEntriesArray] = useState([]);
  const [csvUploaded, setCsvUploaded] = useState(false);

  useEffect(() => {
    if (uploadExcelFile) {
      const reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        data = new Uint8Array(data);
        var workbook = XLSX.read(data, {
          type: "array",
          cellText: false,
          cellDates: true,
        });
        var roa;
        workbook.SheetNames.forEach(function (sheetName) {
          roa = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName],
            { raw: false, dateNF: "yyyy-mm-dd" }
          );
        });
        setTimeout(() => {
          validatingExcelData(roa);
        }, 1000);
      }
      reader.readAsArrayBuffer(uploadExcelFile);
    } else {
      errorTost("Please select valid excel file.");
    }

    return () => { }
  }, [sdrPercent])

  async function validatingExcelData(_excelDataList) {
    setStepperValue(2);
    let getAllUnitsResponse = allUnits;
    const invalidDataArr = [];
    // ? 1. check if all inventory values exist in excel sheet
    let excelSheetUnitsArr = _.map(_excelDataList, (unit) => {
      return {
        Wing: unit.Wing,
        unitNo: unit.unitNo,
        UnitType: unit.UnitType,
        Area: parseInt(unit.Area),

      }
    });
    const getOnlyAvailableUnits = getAllUnitsResponse.filter((f) => f.inventoryStatusId.status === "Available" || f.inventoryStatusId.status === "On Hold" || f.inventoryStatusId.status === "Preselected" || f.inventoryStatusId.status === "Kyc Pending" || f.inventoryStatusId.status === "Kyc Done")
    setDatabaseEntries(getOnlyAvailableUnits.length)
    UnitsList.current = [...getOnlyAvailableUnits];
    let dbUnitsArr = _.map(getOnlyAvailableUnits, (unit) => {
      return {
        Wing: unit.wingName,
        unitNo: unit.unitNo,
        UnitType: unit.inventoryTypeId.type,
        Area: unit.saleableArea,

      }
    });
    dbUnitsArr = _.orderBy(_.orderBy(dbUnitsArr, ['Wing']), (unit) => {
      return parseInt(unit.unitNo);
    });
    excelSheetUnitsArr = _.orderBy(_.orderBy(excelSheetUnitsArr, ['Wing']), (unit) => {
      return parseInt(unit.unitNo);
    });
    setTotalEntriesCount(_excelDataList.length);
    _excelDataList.forEach(element => {
      element.BSP = Math.ceil(element['Agreement Value']);
      element.GST = Math.ceil(element.GST);
      element.SDR = Math.ceil(element.SDR);
      element.Area = parseInt(element.Area);
      element.totalCost = element.BSP + element.GST + element.SDR;
      const validationResult = validateExcelObj(element);
      const validDataArr = [];
      if (!validationResult.validation.isValid) {
        invalidDataArr.push({ ...element, reason: validationResult.validation.reason });
        setFieldLocalEntriesArray([...invalidDataArr].map((m, i) => ({ ...m, id: i })));
      } else {
        validDataArr.push({ ...element })
      }
      let localValidExcelData = [];
      validDataArr.forEach((m) => {
        let ele = { ...m };
        const _unit = getOnlyAvailableUnits.find(f => f.wingId.wingName === m.Wing && f.unitNo === m.unitNo);
        if (_unit) {
          ele.unitId = _unit.unitId;
          localValidExcelData.push(ele);
        }
      })
      uploadingDataToServer(localValidExcelData);
    });
  }

  function validateExcelObj(excelObj) {
    const validation = {
      isValid: true,
      isCalculation: true,
      reason: ''
    };

    if (!excelObj.Wing || excelObj.Wing === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Wing is empty' : validation.reason + ", Wing is empty";
    }

    if (!excelObj.unitNo || excelObj.unitNo === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'unitNo is empty' : validation.reason + ", unitNo is empty";
    }

    if (!excelObj.UnitType || excelObj.UnitType === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'UnitType is empty' : validation.reason + ", UnitType is empty";
    }

    if (excelObj['Agreement Value'] === null || excelObj['Agreement Value'] === undefined || isNaN(excelObj['Agreement Value']) || excelObj['Agreement Value'] === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Agreement value is empty' : validation.reason + ", Agreement Value is empty";
    }

    if (excelObj.Area === null || excelObj.Area === undefined || isNaN(excelObj.Area) || excelObj.Area === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Area is empty' : validation.reason + ", Area is empty";
    }

    //? below 45 lakh AV both 1% and 5% GST are allowed (new launch), 45 lakh and above only 5%
    const isBelowGstSlab = excelObj['Agreement Value'] < 4500000;
    const gstOnePercentVal = Math.round(1 / 100 * excelObj['Agreement Value']);
    const gstFivePercentVal = Math.round(5 / 100 * excelObj['Agreement Value']);
    const allowedGstValues = isBelowGstSlab ? [gstOnePercentVal, gstFivePercentVal] : [gstFivePercentVal];
    const gstVal = allowedGstValues.includes(+excelObj.GST) ? +excelObj.GST : allowedGstValues[0];
    const isGstMatching = allowedGstValues.includes(+excelObj.GST);
    const gstMismatchReason = isBelowGstSlab
      ? `GST Value is not 1% or 5% of ${excelObj['Agreement Value']}`
      : `GST Value is not 5% of ${excelObj['Agreement Value']}`;
    if (excelObj.GST === null || excelObj.GST === undefined || isNaN(excelObj.GST) || excelObj.GST === "" || (+excelObj.GST > 0 && !isGstMatching)) {
      validation.isValid = false;
      if (!isGstMatching) {
        validation.reason = validation.reason === '' ? gstMismatchReason : validation.reason + ", " + gstMismatchReason;
      } else {
        validation.reason = validation.reason === '' ? 'GST is empty' : validation.reason + ", GST is empty";
      }

    }

    //? sdrpercent *  AV + (1% of AV or 30k which ever is less) + 15k default
    const sdrVal = (Math.ceil(Math.round((Number(excelObj['Agreement Value']) * sdrPercent) / 100) / 100) * 100) +
      (excelObj['Agreement Value'] > 3000000 ? (Math.ceil(Number(registrationCharges / 100) * 100)) : (Math.ceil(Number(excelObj['Agreement Value'] / 100) / 100) * 100)) + legalChargeVal


    if (excelObj.SDR === null || excelObj.SDR === undefined || isNaN(excelObj.SDR) || excelObj.SDR === "" || (+excelObj.SDR > 0 && +excelObj.SDR !== sdrVal)) {
      validation.isValid = false;
      if (+excelObj.SDR !== sdrVal) {
        validation.reason = validation.reason === '' ? `SDR Value is not ${sdrPercent}% of ${excelObj['Agreement Value']} ` : validation.reason + `SDR Value is not ${sdrPercent}% of ${excelObj['Agreement Value']} `;
      } else {
        validation.reason = validation.reason === '' ? 'SDR is empty' : validation.reason + ", SDR is empty";
      }

    }

    const TotalCostValue = Math.round((+excelObj.SDR > 0 ? sdrVal : 0) + parseInt(excelObj['Agreement Value']) + (+excelObj.GST > 0 ? gstVal : 0))
    if (excelObj.TotalCost === null || excelObj.TotalCost === undefined || isNaN(excelObj.TotalCost) || excelObj.TotalCost === "" || +excelObj.TotalCost !== TotalCostValue) {
      validation.isValid = false;
      if (+excelObj.TotalCost !== TotalCostValue) {
        validation.reason = validation.reason === '' ? 'TotalCost is incorrect' : validation.reason + ", TotalCost is incorrect";
      } else {
        validation.reason = validation.reason === '' ? 'TotalCost is empty' : validation.reason + ", TotalCost is empty";
      }

    }

    return { validation, excelObj };
  }

  async function uploadingDataToServer(_excelDataList) {
    setStepperValue(3);
    for (const UnitsObj of _excelDataList) {
      const addToServerResponse = await addToServer(_excelDataList);
      if (addToServerResponse.success) {
        newEntriesCount.current = newEntriesCount.current + 1;
      } else if (addToServerResponse?.is_failed) {
        fieldServerEntriesArray.current = [...fieldServerEntriesArray.current, { ...UnitsObj, reason: addToServerResponse.reason }];
      }
    }
  }

  async function createPriceForUnits(UnitsObj) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.REACT_APP_PAYMENT_LINK_URL + 'units/getToken').then(async (resp) => {
        const chunksData = chunk(UnitsObj, 50)
        for (const element of chunksData) {
          const response = await sendData(element, resp);
        }

      })
    });
  }

  function sendData(element, resp) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + `units/updateInventoryPrice?token=${resp.data.token}`, { units: element }).then((updateRes) => {
        var source = new EventSource(process.env.REACT_APP_PAYMENT_LINK_URL + `units/getCount?token=${resp.data.token}`)
        source.addEventListener(
          "message",
          function (e) {
            const _preCount = parseInt(countRef.current);
            countRef.current = parseInt(_preCount + parseInt(JSON.parse(e.data)?.updatedCount));
            setCount(countRef.current); ////* ignore
            if (JSON.parse(e.data)?.processFinished) {
              source.removeEventListener("message", this);
              source.close();
              if (+countRef.current === +UnitsList.current.length) {
                successTost("Unit prices updated successfully!")
                respValue(true)
                let obj = {
                  csvUploaded: true,
                }
                setStepperValue(4);
                updateFlagsToProjectTable(obj, projectId).then((response) => {
                  setCsvUploaded(true);
                }).catch((err) => {
                  console.error("updateFlagsToProjectTable", err)
                  setCsvUploaded(false);
                })
              }
              resolve({ success: true })
            }
          },
        )
      })
    })
  }

  function addToServer(UnitsObj) {
    return new Promise(async (resolve, reject) => {
      const createPriceForUnitsResponse = await createPriceForUnits(UnitsObj);
      if (createPriceForUnitsResponse.data) {
        resolve({ success: true });


      } else {
        if (createPriceForUnitsResponse.error.details.includes("already exists")) {
          resolve({ success: false, is_failed: true, reason: createPriceForUnitsResponse.error.details });
        } else {
          resolve({ success: false, is_failed: true, reason: createPriceForUnitsResponse.error.message });
        }
      }
    })
  }


  return (
    <>
      <Modal
        open={open}
        onClose={() => { handleClose(csvUploaded) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[{ ".MuiBackdrop-root": { background: "rgba(193, 201, 210, 0.7)" } }]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.header}>
            <h1>Uploading Data</h1>
          </div>

          <div className={cssClasses.mainContainer}>
            <div className={cssClasses.mainContainerWrapper}>

              {/* Step 1 */}
              <div className={cssClasses.progressCardContainer}>
                <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} mb={"1rem"} p={"1rem 1.5rem"}>
                  <Typography color={"#0F0F0F"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}>Reading Excel</Typography>
                  {
                    stepperValue > 1 ?
                      <CheckCircleIcon color={"primary"} style={{ width: "2rem", height: "2rem" }} />
                      :
                      <CheckCircleIcon color={"primary"} style={{ width: "2rem", height: "2rem", opacity: "0.5" }} />
                  }
                </Box>
                {
                  (stepperValue > 1) ?
                    <LinearProgress variant="determinate" value={100} />
                    :
                    <LinearProgress />
                }
              </div>

              {/* Step 2 */}
              <div className={cssClasses.progressCardContainer}>
                <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} mb={"1rem"} p={"1rem 1.5rem"}>
                  <Typography color={"#0F0F0F"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}>Validating Data in Excel</Typography>
                  {
                    (stepperValue > 2) ?
                      <CheckCircleIcon color={"primary"} style={{ width: "2rem", height: "2rem" }} />
                      :
                      <CheckCircleIcon color={"primary"} style={{ width: "2rem", height: "2rem", opacity: "0.5" }} />
                  }
                </Box>
                {
                  (stepperValue > 2) ?
                    <LinearProgress variant="determinate" value={100} />
                    :
                    <LinearProgress />
                }
              </div>

              {/* Step 2 */}
              <div className={cssClasses.progressCardContainer}>
                <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} mb={"1rem"} p={"1rem 1.5rem"}>
                  <Typography color={"#0F0F0F"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}>Uploading Data to Database</Typography>
                  {
                    stepperValue === 3 && totalEntriesCount - fieldLocalEntriesArray.length === countRef.current ?
                      <CheckCircleIcon color={"primary"} style={{ width: "2rem", height: "2rem" }} />
                      :
                      <CheckCircleIcon color={"primary"} style={{ width: "2rem", height: "2rem", opacity: "0.5" }} />
                  }
                </Box>
                {
                  (stepperValue > 3) ?
                    <LinearProgress variant="determinate" value={100} />
                    :
                    stepperValue === 3
                      ?
                      <LinearProgress variant="determinate" value={(((countRef.current)) / (totalEntriesCount - fieldLocalEntriesArray.length)) * 100} />
                      :
                      <LinearProgress />
                }
              </div>
              <div className={cssClasses.progressCardContainer} style={{ padding: "1rem 1.5rem" }}>
                <Typography color={"#676767"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}>Total Entries : {totalEntriesCount}</Typography>
                <Typography color={"#676767"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}>New Entries : {countRef.current}</Typography>
                <Typography color={"#676767"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}>Failed Entries : {fieldLocalEntriesArray.length}</Typography>
              </div>
            </div>
          </div>

          <div className={cssClasses.footer}>
            {(fieldServerEntriesArray.current && fieldServerEntriesArray.current?.length > 0) &&
              <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <Typography color={"#0F0F0F"} fontSize={"2rem"} lineHeight={"3rem"} fontWeight={400}> View Field Entries </Typography>
                <Box display={"flex"}>
                  <Button style={{ color: "#344054", backgroundColor: "#ffffff", border: "1px solid #E5E7EB" }} btnName={"View"} clicked={() => { setIsFieldEntriesModalOpen(true) }} />
                  <div style={{ marginLeft: "1rem" }}><Button style={{ color: "#344054", backgroundColor: "#ffffff", border: "1px solid #E5E7EB" }} btnName={"Close"} clicked={() => { handleClose(true) }} /></div>
                </Box>
              </Box>
            }

            <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
              {fieldLocalEntriesArray.length > 0 && (
                <Box marginRight={"2rem"}>
                  <Button style={{ color: "#ffffff", backgroundColor: "#3B82F6", width: 'auto' }} btnName={"View Failed Entries"} clicked={() => setIsFieldLocalEntriesModalOpen(true)} />
                </Box>
              )}
              <Button style={{ color: "#ffffff", backgroundColor: "#3B82F6", width: 'auto' }} btnName={"Close"} clicked={() => handleClose(csvUploaded)} />
            </Box>
          </div>
        </Box>
      </Modal>

      {
        isFieldEntriesModalOpen &&
        <FieldEntriesModal
          open={isFieldEntriesModalOpen}
          handleClose={() => setIsFieldEntriesModalOpen(false)}
          fieldEntriesArray={fieldServerEntriesArray.current?.map((m, i) => ({ ...m, id: i }))}
          DatabaseTotal={DatabaseEntries}
        />
      }

      {/* //todo -----------> Local Field entries on close modal close all process  */}
      {
        isFieldLocalEntriesModalOpen &&
        <FieldEntriesModal
          open={isFieldLocalEntriesModalOpen}
          handleClose={() => {
            setIsFieldLocalEntriesModalOpen(false);
          }}
          fieldEntriesArray={fieldLocalEntriesArray}
          DatabaseTotal={DatabaseEntries}
        />
      }
    </>
  )
}

export default UploadingDataModal